import React from 'react';
import {
    Box,
    Button,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Grid,
    Typography,
    IconButton,
} from '@mui/material';
import { meryville } from '../../../util/themes';

import CloseIcon from '@mui/icons-material/Close';

import { Icon } from '@iconify/react';
import { accountCheck, circleOutline } from '../components/pathwayIcons';

interface IProps {
    setOpenPopup: (val: boolean) => void;
    activities?: any[];
    title?: string;
    label?: string;
}

const styles = {
    title: {
        fontSize: '24px',
        fontWeight: 600,
        letterSpacing: 0,
        lineHeight: '36px',
    },
    label: {
        color: meryville.palette.grey[400],
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        lineHeight: meryville.spacing(3),
        display: 'block',
    },
};

export function ActivityPopup(props: IProps) {
    const { setOpenPopup, activities, label, title } = props;

    const onClose = () => {
        setOpenPopup(false);
    };

    const getIcon = (status: string) => {
        const iconFontSize = '30px';
        if (status === 'complete') {
            return <Icon icon={accountCheck} style={{ color: meryville.palette.success.light, fontSize: iconFontSize }}/>;
        } else {
            return <Icon icon={circleOutline} />;
        }
    };

    return (
        <Grid container>
            <Box
                sx={{
                    width: '100%',
                    m: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box>
                    <Typography variant="body1" sx={styles.label}>
                        {label}
                    </Typography>
                    <Typography variant="h6" sx={styles.title}>
                        {title}
                    </Typography>
                </Box>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    mx: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box>
                    <Typography variant="body1" sx={styles.label}>
                        Skills
                    </Typography>
                </Box>
                <Button variant="contained" size="small" color="secondary">
                    Resume
                </Button>
            </Box>

            <Grid item xs={12} style={{ width: '500px' }}>
                <List>
                    {React.Children.toArray(
                        activities?.map((activity: any) => {
                            return (
                                <ListItem disablePadding>
                                    <ListItemButton>
                                        <ListItemIcon>
                                            {getIcon(activity.status)}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={activity.title}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })
                    )}
                </List>
            </Grid>
        </Grid>
    );
}
